import React, { useState, useEffect, Fragment } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { Link } from 'react-router-dom';

import { Create, Add, BeenhereRounded, Visibility } from '@material-ui/icons';

import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';

import { wsGetAll } from 'services/WService.js';

import ModalCategory from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
});

const categoryTableColumns = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: 'Opciones', accessor: 'options', excelEnabled: false },
  { Header: 'Código', accessor: 'code' },
  { Header: 'Descripción', accessor: 'description' },
  { Header: 'Nombre proveedor', accessor: 'CardName' },
  { Header: 'Estado', accessor: 'state' },
  { Header: '', accessor: 'actions', excelEnabled: false }
];

export default WithApp(function Category(props) {
  const classes = useStyles();
  const [model, setOpen] = useModal();
  const [notify, showNotify] = useToasty();

  const [categories, setCategories] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);

  async function loadCategories() {
    setDataLoading(true);
    let response = await wsGetAll('logi/category');
    setDataLoading(false);
    if (response.success) setCategories(response.data);
  }

  useEffect(() => {
    loadCategories();
  }, []);

  return (
    <GridContainer>
      <Toasty action={notify} />
      <ModalCategory
        model={model}
        setOpen={setOpen}
        showNotify={showNotify}
        reload={loadCategories}
      />

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.LOGI_CATEGORIES_STORE}
              component={
                <CardIcon color="primary">
                  <BeenhereRounded style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpen({})}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>Listado de categorías {dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              excelName="Categorías"
              defaultWidth={1100}
              indexRow={[0, 1, 2, 6]}
              widthRow={[50,150, 100, 5]}
              columns={categoryTableColumns}
              data={categories.map((category, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                    </div>
                  ),
                  options: (
                    <Fragment>
                      <AllowedGuard permission={ConstantPermissions.LOGI_CATEGORIES_UPDATE}>
                        <Button
                          justIcon
                          round
                          simple
                          color="info"
                          className="like"
                          onClick={() => setOpen(category)}
                        >
                          <Create />
                        </Button>
                      </AllowedGuard>

                      {/* Ver detalles de categorias (Lineas) */}
                      <Button justIcon round simple color="primary">
                        <Link to={`${category.id}`}>
                          <Visibility />
                        </Link>
                      </Button>

                      <AllowedGuard permission={ConstantPermissions.LOGI_CATEGORIES_DELETED}>
                        <ButtonDelete
                          entity="logi/category"
                          id={category.id}
                          reload={loadCategories}
                        />
                      </AllowedGuard>
                    </Fragment>
                  ),
                  code: category.code,
                  description: category.description,
                  CardName: category.CardName,
                  state: category.state === 'A' ? 'Activo' : 'Inactivo',
                  actions: '',
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
